<template>
  <div :class="$style.root" v-on="$listeners">
    <slot :imgClass="$style.img"></slot>
    <slot name="character" :characterClass="$style.character">
      <Character :class="$style.character" />
    </slot>
  </div>
</template>

<script>
import Character from './Character'

export default {
  components: {
    Character,
  },
}
</script>

<style lang="scss" module>
.root {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: "one";
}

.img,
.character {
  grid-area: one;
  @apply w-full;
  @apply h-full;
  @apply object-contain;
  @apply object-center;
}
</style>
